var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "solar:phone-bold-duotone"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1501 20.0385L24.8341 19.359C25.7791 18.42 27.2506 18.2265 28.4596 18.8835L31.3246 20.442C33.1651 21.4425 33.5716 23.895 32.1331 25.3245L30.0031 27.4425C29.4601 27.9825 28.7881 28.3755 28.0141 28.4475C26.2261 28.614 22.5466 28.524 18.2056 25.983L24.1501 20.0385ZM15.2851 11.2245L15.7156 10.7955C16.7761 9.74253 16.8766 8.05053 15.9511 6.81453L14.0611 4.29003C12.9151 2.76003 10.7026 2.55753 9.39006 3.86253L7.03506 6.20253C6.38556 6.85053 5.95056 7.68753 6.00306 8.61753C6.10056 10.3275 6.68256 13.4475 9.22656 17.2815L15.2851 11.2245Z",
    fill: "#0073FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.6,
    d: "M18.0946 17.2455C13.6756 12.852 15.2746 11.2335 15.2851 11.223L9.22656 17.283C10.2271 18.789 11.5291 20.4045 13.2226 22.089C14.9326 23.79 16.6126 25.0515 18.2056 25.983L24.1501 20.04C24.1501 20.04 22.5271 21.654 18.0946 17.247",
    fill: "#0073FF"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.dbd1a201728bbf0130ba18eb575c022c.svg";
export { ForwardRef as ReactComponent };